import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { schemaActaPaso2 } from "../../../schemas/validacionesActa";
import Loading from "../../../components/Loading";
import { createActaPaso2 } from "../../../api/acta";
import { useFormActaStore } from "../../../store/formActaStore";

import "leaflet/dist/leaflet.css";
import MapaActa2 from "../../Mapas/MapaActa2";
import { getTiposSolicitudesHandler, segundaEtapaHandler } from "../../../handlers/actas.handler";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import useWindowSize from "../../../hooks/useWindowSize";
import SubirFotos from "./SubirFotos";
import ArrowDerechoIcon from "../../../components/svgs/ArrowDerechoIcon";

const FormActa2 = () => {
  const size = useWindowSize();
  const { width } = size;
  const { loading, setLoading, setUltimoPaso, acta_id, defaultValues, tiposSolicitudes } =
    useFormActaStore();
  const { loads } = useGeneralAppStore();
  const [sendForm, setSendForm] = useState(false);

  const {
    register,
    watch,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    clearErrors,
    control,
    resetField,
  } = useForm({
    // defaultValues: {
    //     solicita: null,
    //     motivo: null,
    //     cantidad_arboles: null,
    //     latitud: null,
    //     longitud: null,
    // },
    defaultValues: defaultValues,
    resolver: yupResolver(schemaActaPaso2),
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "tipos_solicitud",
  });

  const tipoSeleccionado = watch("tipos_solicitud");

  const toggleTipo = (tipo) => {
    const index = getValues("tipos_solicitud").findIndex((t) => t.id === tipo.id);
    if (index >= 0) {
      remove(index);
    } else {
      append({ id: tipo.id, cantidad_arboles: "" });
    }
  };

  const isChecked = (tipoId) => {
    return tipoSeleccionado.some((tipo) => Number(tipo.id) === tipoId);
  };

  const onSubmit = (data) => {
    const newData = {
      id: data.id,
      lugar: data.lugar,
      tipo_persona_solicitante: data.tipo_persona_solicitante,
      solicitante: data.solicitante,
      tipos_solicitud: data.tipos_solicitud,
      descripcion: data.descripcion,
      latitud: data.latitud,
      longitud: data.longitud,
      ubicacion: [data.latitud, data.longitud],
      files: data.files,
    };
    // return console.log(newData);
    segundaEtapaHandler(newData);

    // createActaPaso2({ ...data, acta_id: acta_id, ubicacion: [watch('latitud'), watch('longitud')] }, setLoading, setUltimoPaso, setSendForm)
  };

  useEffect(() => {
    if (watch("tipo_persona_solicitante") == "propietario/locatario") {
      setValue("solicitante", defaultValues.nombre_ciudadano);
    } else {
      resetField("solicitante");
    }
  }, [watch("tipo_persona_solicitante")]);

  useEffect(() => {
    if (!tiposSolicitudes) {
      getTiposSolicitudesHandler();
    }
  }, [tiposSolicitudes]);

  return (
    <>
      <motion.div
        key="form"
        initial={{ opacity: 0 /* , x: 100 */ }}
        animate={{ opacity: 1 /* , x: 0 */ }}
        exit={{ opacity: 0 /* , x: -100  */ }}
        transition={{ duration: 0.5 }}
        className=" w-100 position-relative"
      >
        {(loads.includes("load_form") || loads.includes("tipos_solicitudes")) && (
          <div
            className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center "
            style={{ background: "rgba(255,255,255,0.8)", zIndex: 9999 }}
          >
            <Loading sizeIcono="50px" sizeLoad="70px" font="16px" />
          </div>
        )}

        <Form noValidate onSubmit={handleSubmit(onSubmit)} className="col-12 mx-auto mb-4">
          <div /* className='row' */ className={`${width <= 992 ? " " : "d-flex"}`}>
            <section className={`${width <= 992 ? "col-12" : "col-5"}`}>
              <Form.Group className="">
                <Form.Label className="m-0">Dirección (lugar de poda)</Form.Label>
                <Form.Control
                  placeholder="Dirección . . ."
                  type="text"
                  {...register("lugar")}
                  isInvalid={!!errors.lugar}
                />
                <Form.Control.Feedback className="mensajeError-sm mensajeError-md" type="invalid">
                  {errors.lugar?.message}
                </Form.Control.Feedback>
                {!errors.lugar?.message && <div style={{ height: "25px" }}></div>}
              </Form.Group>

              <Form.Group>
                <Form.Label className="m-0">Tipo de persona solicitante</Form.Label>
                <div>
                  <Form.Check
                    type="radio"
                    id="tipoPersona"
                    label="Propietario/Locatario"
                    value="propietario/locatario"
                    {...register("tipo_persona_solicitante")}
                  />
                  <Form.Check
                    type="radio"
                    id="tipoPersona2"
                    label="Tercero"
                    value="tercero"
                    {...register("tipo_persona_solicitante")}
                  />
                </div>
                <Form.Group className="">
                  <Form.Control
                    disabled={!watch("tipo_persona_solicitante")}
                    placeholder="Especificar tercero . . ."
                    type="text"
                    {...register("solicitante")}
                    isInvalid={!!errors.solicitante}
                  />
                  {/* {
                    watch('tipo_persona_solicitante') &&
                    <>
                      <Form.Control.Feedback className="mensajeError-sm mensajeError-md" type="invalid">
                        {errors.solicitante?.message}
                      </Form.Control.Feedback>
                      {!errors.solicitante?.message && <div style={{ height: "25px" }}></div>}
                    </>
                  } */}
                </Form.Group>
                {/* {
                  !watch('tipo_persona_solicitante') &&
                  <> */}
                <Form.Control.Feedback
                  className="mensajeError-sm mensajeError-md"
                  type="invalid"
                  style={{ display: errors.solicitante ? "block" : "none" }}
                >
                  {errors.solicitante?.message}
                </Form.Control.Feedback>
                {!errors.solicitante?.message && <div style={{ height: "25px" }}></div>}
                {/* </>
                } */}
              </Form.Group>

              {width <= 992 && (
                <div className={`${width <= 992 ? "col-12" : "col-10"} mx-auto`}>
                  <Form.Group>
                    <Form.Label className="m-0">
                      Tipo de solicitud{" "}
                      <span style={{ color: "#395CF1" }}> (Ingrese cant. de arboles)</span>
                    </Form.Label>
                    <div>
                      {tiposSolicitudes?.map((tipo) => {
                        const index = tipoSeleccionado.findIndex((t) => Number(t.id) === tipo.id);
                        return (
                          <div
                            key={tipo.id}
                            className="d-flex gap-2 align-items-center mb-2"
                            style={{ height: "31px" }}
                          >
                            <Form.Check
                              // isInvalid={errors?.tipos_solicitud?.cantidad_arboles && (watch('tipos_solicitud').some((sol) => sol))}
                              isInvalid={Boolean(
                                errors?.tipos_solicitud?.[index]?.cantidad_arboles
                              )}
                              id={`check${tipo.id}`}
                              type="checkbox"
                              label={width <= 640 ? tipo.nombre.split(" ")[0] : tipo.nombre}
                              checked={isChecked(tipo.id)}
                              onChange={() => toggleTipo(tipo)}
                            />
                            {/* <label >{tipo.nombre}</label> */}
                            {isChecked(tipo.id) && (
                              <Controller
                                name={`tipos_solicitud.${index}.cantidad_arboles`}
                                control={control}
                                render={({ field }) => (
                                  <Form.Control
                                    size="sm"
                                    {...field}
                                    type="number"
                                    placeholder="Cantidad . . ."
                                    style={{ width: "90px" }}
                                    onKeyDown={(e) => {
                                      if (
                                        [
                                          "ArrowUp",
                                          "ArrowDown",
                                          "e",
                                          "E",
                                          "+",
                                          "-",
                                          ".",
                                          ",",
                                        ].includes(e.key)
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    onWheel={(e) => e.currentTarget.blur()}
                                  />
                                )}
                              />
                            )}
                            {errors?.tipos_solicitud?.[index]?.cantidad_arboles && (
                              <Form.Control.Feedback
                                type="invalid"
                                className="mensajeError-sm mensajeError-md"
                                style={{ display: "block" }}
                              >
                                {errors.tipos_solicitud[index].cantidad_arboles.message}
                              </Form.Control.Feedback>
                            )}
                            {isChecked(tipo.id) && (
                              <input
                                type="hidden"
                                {...register(`tipos_solicitud.${index}.id`)}
                                value={tipo.id}
                              />
                            )}
                          </div>
                        );
                      })}
                    </div>
                    <Form.Control.Feedback
                      className="mensajeError-sm mensajeError-md"
                      type="invalid"
                      style={{ display: errors.tipos_solicitud ? "block" : "none" }}
                    >
                      {errors.tipos_solicitud?.message}
                    </Form.Control.Feedback>
                    {!errors.tipos_solicitud?.message && <div style={{ height: "25px" }}></div>}
                  </Form.Group>
                </div>
              )}

              <Form.Group className="">
                <Form.Label className="m-0">Descripción</Form.Label>
                <Form.Control
                  placeholder="Describa la problematica . . ."
                  as="textarea"
                  cols={50}
                  rows={5}
                  type="text"
                  {...register("descripcion")}
                  style={{ resize: "none" }}
                  isInvalid={!!errors.descripcion}
                />
                <Form.Control.Feedback className="mensajeError-sm mensajeError-md" type="invalid">
                  {errors.descripcion?.message}
                </Form.Control.Feedback>
                {!errors.descripcion?.message && <div style={{ height: "25px" }}></div>}
              </Form.Group>

              <Form.Group className="col-12">
                <Form.Label className={`m-0  ${width < 640 ? "text-center w-100" : ""}`}>
                  Ubicación (opcional)
                </Form.Label>
                <div
                  className={`${
                    errors.latitud ? "border border-2 border-danger" : "border-primary"
                  } border border-2  col-12 `}
                  style={{ height: width <= 640 ? "190px" : "310px" }}
                >
                  <MapaActa2
                    setValue={setValue}
                    clearErrors={clearErrors}
                    latitud={watch("latitud")}
                    longitud={watch("longitud")}
                    sendForm={sendForm}
                    setSendForm={setSendForm}
                    id={watch("id")}
                  />
                </div>
                <div className="mt-1" style={{ height: "25px" }}>
                  {errors.latitud && <span className="text-danger">{errors.latitud.message}</span>}
                </div>
              </Form.Group>
            </section>
            <section className={`${width <= 992 ? "col-12" : "col-7"} `}>
              {width > 992 && (
                <div className={`${width <= 992 ? "col-12" : "col-10"} mx-auto`}>
                  <Form.Group className="">
                    <Form.Label className="m-0">
                      Tipo de solicitud{" "}
                      <span style={{ color: "#395CF1" }}> (Ingrese cant. de arboles)</span>
                    </Form.Label>
                    <div>
                      {tiposSolicitudes?.map((tipo) => {
                        const index = tipoSeleccionado.findIndex((t) => Number(t.id) === tipo.id);
                        return (
                          <div
                            key={tipo.id}
                            className="d-flex gap-2 align-items-center mb-2"
                            style={{ height: "31px" }}
                          >
                            <Form.Check
                              id={`check${tipo.id}`}
                              type="checkbox"
                              label={width <= 640 ? tipo.nombre.split(" ")[0] : tipo.nombre}
                              checked={isChecked(tipo.id)}
                              onChange={() => toggleTipo(tipo)}
                            />
                            {/* <label >{tipo.nombre}</label> */}
                            {isChecked(tipo.id) && (
                              <Controller
                                name={`tipos_solicitud.${index}.cantidad_arboles`}
                                control={control}
                                render={({ field }) => (
                                  <Form.Control
                                    size="sm"
                                    {...field}
                                    type="number"
                                    placeholder="Cantidad . . ."
                                    style={{ width: "90px" }}
                                    onKeyDown={(e) => {
                                      if (
                                        [
                                          "ArrowUp",
                                          "ArrowDown",
                                          "e",
                                          "E",
                                          "+",
                                          "-",
                                          ".",
                                          ",",
                                        ].includes(e.key)
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    onWheel={(e) => e.currentTarget.blur()}
                                  />
                                )}
                              />
                            )}
                            {isChecked(tipo.id) && (
                              <input
                                type="hidden"
                                {...register(`tipos_solicitud.${index}.id`)}
                                value={tipo.id}
                              />
                            )}
                          </div>
                        );
                      })}
                    </div>
                    <Form.Control.Feedback
                      className="mensajeError-sm mensajeError-md"
                      type="invalid"
                      style={{ display: errors.tipos_solicitud ? "block" : "none" }}
                    >
                      {errors.tipos_solicitud?.message}
                    </Form.Control.Feedback>
                    {!errors.tipos_solicitud?.message && <div style={{ height: "25px" }}></div>}
                  </Form.Group>
                </div>
              )}

              <label className="mx-auto  w-100 text-center mb-1">Adjuntar archivos</label>

              <SubirFotos watch={watch} errors={errors} setValue={setValue} control={control} />
            </section>
          </div>
          {width >= 640 && <hr className="mt-4 mb-4" />}
          <div
            className={`d-flex align-items-center  justify-content-end ${
              width >= 640 ? "pe-4" : ""
            }`}
          >
            <button
              // disabled={Object.keys(errors).length !== 0}
              className="col- btn btn-primary "
              type="submit"
            >
              Siguiente
              <ArrowDerechoIcon width={20} height={20} color="#fff" />
            </button>
          </div>
        </Form>
      </motion.div>
      {/* } */}
    </>
  );
};
export default FormActa2;
